import React from 'react';
import SIcon from './SIcon';
import { faUniversalAccess } from '@fortawesome/pro-solid-svg-icons';

const Icon = props => <SIcon {...props} icon={faUniversalAccess} fa />;

export default Icon;
